import type { StageConfig } from '@capture/shared';
import { MinimumRoleSelect } from './MinimumRoleSelect';

export function SupervisorPanel({ config, onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  const minimumRole = (config.config.minimumRole as string) ?? 'supervisor';
  return (
    <div className="stage-panel">
      <label>
        Minimum role
        <MinimumRoleSelect value={minimumRole} onChange={(v) => onChange({ ...config, config: { ...config.config, minimumRole: v } })} />
      </label>
    </div>
  );
}
